import { Col, Container } from 'react-bootstrap';
import RelatedBlogs from '@/components/blog/related_blogs';
import React from 'react';
import { BlogEnum } from '@/types/translations/BlogEnum';
import { SkuEnum } from '@/types/translations/SkuEnum';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { PrimaryButtonLink } from '@/components/common/PrimaryButton';
import Accordion from 'react-bootstrap/Accordion';
import { SkusBrandContentProps } from '@/types/props/components/skus';

export default function SkusBrandContent({
  brandsContent,
}: SkusBrandContentProps) {
  const { translate: translateBlog } = useTypedTranslation<BlogEnum>('blog');
  const { translate: translateSku } = useTypedTranslation<SkuEnum>('sku');

  return (
    <>
      <div className={'brands_content_box'}>
        <link rel="stylesheet" href="/css/brands.css" />
        <Col
          className={`tw-bg-customGray tw-py-[60px] brands_latest_articles tw-mt-[60px]`}
        >
          <Container className="">
            <h2 className={`tw-font-semibold tw-text-[24px] tw-mb-[15px]`}>
              {translateBlog(BlogEnum.latest_articles)}
            </h2>
            <div
              className={`tw-rounded-[20px] tw-bg-custom-gold tw-h-[5px] tw-max-w-[100px] tw-mb-[40px]`}
            ></div>
            <RelatedBlogs blogtitle={''}></RelatedBlogs>
            <PrimaryButtonLink
              href={'/blog'}
              outlined={true}
              className={
                'd-flex mx-auto font-weight-bold justify-content-center tw-mt-[25px] tw-px-[60px] tw-w-auto tw-w-[fit-content]'
              }
            >
              {translateBlog(BlogEnum.all_articles)}
            </PrimaryButtonLink>
          </Container>
        </Col>
        <Container className={'brands_content_content'}>
          <Col className={`tw-mt-[60px] mx-auto`} md={8}>
            <div
              className={`content_first_para`}
              dangerouslySetInnerHTML={{
                __html: brandsContent?.content_first_para || '',
              }}
            ></div>
            <div
              className={`table_content_content tw-rounded-[20px] tw-bg-customGray tw-p-[30px] tw-my-[30px]`}
            >
              <h3 className={`tw-pb-[20px]`}>
                {' '}
                {translateBlog(BlogEnum.content_table)}
              </h3>

              <div
                dangerouslySetInnerHTML={{
                  __html: brandsContent?.content_table || '',
                }}
              ></div>
            </div>
            <div
              className={`content_content`}
              dangerouslySetInnerHTML={{
                __html: brandsContent?.content_text || '',
              }}
            ></div>
          </Col>
        </Container>
        <Col
          className={`tw-bg-customGray tw-py-[60px] tw-mt-[60px] faqsection`}
        >
          <Container className="">
            <div className="tw-flex tw-mb-[40px] tw-align-items-center tw-justify-between max-sm:tw-flex-col max-sm:tw-text-center">
              <h2>{translateSku(SkuEnum.do_you_have_any_questions)}</h2>
              <PrimaryButtonLink
                href={'mailto:info@spiritory.com'}
                outlined={true}
                className={
                  'd-flex font-weight-bold justify-content-center tw-px-[60px] max-sm:tw-m-auto max-sm:tw-mt-[15px]'
                }
              >
                {translateSku(SkuEnum.contact_us)}
              </PrimaryButtonLink>
            </div>

            <Accordion>
              {brandsContent?.faqs &&
                typeof brandsContent.faqs === 'object' &&
                Object.entries(brandsContent.faqs).map(([key, item], index) => (
                  <Accordion.Item eventKey={`${index}`} key={key}>
                    <Accordion.Header>
                      {item.question}{' '}
                      {/* Zugriff auf die `question`-Eigenschaft */}
                    </Accordion.Header>

                    <Accordion.Body>
                      {item.answer} {/* Zugriff auf die `answer`-Eigenschaft */}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
          </Container>
        </Col>
      </div>
    </>
  );
}
